<template>
  <Moveable
      ref="emoji"
      class="emoji-entity"
      v-bind="moveable"
      @drag="handleDrag"
      @resize="handleResize"
      @rotate="handleRotate"
      :bounds="bounds"
      :style="style"
      v-if="emoji"
  >
    <div class="delete" @click="remove" ref="delete">
      <img src="/src/img/delete.svg">
    </div>
    <img :src="host + emoji.icon"/>
  </Moveable>
</template>

<script>
import Moveable from "vue-moveable";

export default {
  name: 'EmojiEntity',
  components: {Moveable},
  props: {
    emojiLocation: {
      type: Object,
      required: true
    },
    container: {
      required: true
    }
  },

  data() {
    return {
      window: {
        rect: null
      },
      moveable: {
        className: 'emoji-control-' + this._uid,
        draggable: true,
        throttleDrag: 1,
        resizable: true,
        throttleResize: 1,
        keepRatio: true,
        scalable: false,
        throttleScale: 0.01,
        rotatable: true,
        throttleRotate: 0.2,
        pinchable: false,
        origin: false,
        dragArea: true,
        snappable: true,
      },
      style: ''
    }
  },

  created() {
    // get container rect
    this.window.rect = this.container.getBoundingClientRect()

    // update container rect to keep bounds responsive
    window.addEventListener('resize', () => {
      this.window.rect = this.container.getBoundingClientRect()
    })

    let x = this.bounds.width / 100 * this.emojiMap.transform.x
    let y = this.bounds.height / 100 * this.emojiMap.transform.y

    let width = this.bounds.width / 100 * this.emojiMap.transform.w;

    if (x === 0 && y === 0) {
      let rect = this.container.getBoundingClientRect()
      let emojiCenter = this.emojiMap.transform.w / 2

      x = (rect.right - rect.left) / 2 - emojiCenter
      y = (rect.bottom - rect.top) / 2 - emojiCenter
    }

    this.style = `position:absolute; width: ${width}px; transform: translateY(${y}px) translateX(${x}px) rotate(${this.emojiMap.transform.rotation}deg)`
  },

  computed: {
    /**
     * get server host url
     */
    host: function () {
      return this.$store.getters.host();
    },

    /**
     * get container bounds
     */
    bounds() {
      return {
        left: this.window.rect.left,
        right: this.window.rect.right,
        top: this.window.rect.top  + window.scrollY,
        bottom: this.window.rect.bottom  + window.scrollY,
        width: this.window.rect.width,
        height: this.window.rect.height
      }
    },

    /**
     * get emojis img obj
     */
    emoji() {
      return this.$store.getters.emojis.find(e => e.id === +this.emojiMap.emojiId)
    },

    /**
     * get emojis map location obj
     */
    emojiMap: {
      get: function () {
        return this.emojiLocation
      },
      set: function (emojiMap) {
        this.$store.commit('updateEmoji', emojiMap)
      }
    },
  },

  methods: {
    handleDrag({target, transform, right, left}) {
      target.style.transform = transform;

      let rect = target.getBoundingClientRect()

      // calculate top position
      let topPos = Math.round(rect.top - this.bounds.top)
      topPos = topPos <= 0 ? 0 : topPos
      let topPercentage = 100 / this.bounds.height * topPos

      // calculate bottom position
      let leftPos = Math.round(rect.left - this.bounds.left)
      leftPos = leftPos < 0 ? 0 : leftPos
      let leftPercentage = 100 / this.bounds.width * leftPos

      this.updateEmojiLocation({x: leftPercentage, y: topPercentage})
    },

    handleResize({target, width, height}) {

      let widthPercentage = 100 / this.bounds.width * width
      let heightPercentage = 100 / this.bounds.height * height

      target.style.width = `${widthPercentage}%`
      target.style.height = `${heightPercentage}%`

      widthPercentage = 100 / this.bounds.width * target.offsetWidth
      heightPercentage = 100 / this.bounds.height * height.offsetHeight

      this.updateEmojiLocation({w: widthPercentage, h: heightPercentage})
    },

    handleRotate({target, transform, rotate}) {
      target.style.transform = transform

      let rotation = rotate

      // calculate real rotation angel if target has an matrix
      var st = window.getComputedStyle(target, null);
      var tm = st.getPropertyValue("-webkit-transform") ||
          st.getPropertyValue("-moz-transform") ||
          st.getPropertyValue("-ms-transform") ||
          st.getPropertyValue("-o-transform") ||
          st.getPropertyValue("transform") ||
          null;
      if (tm) {
        var values = tm.split('(')[1].split(')')[0].split(',');
        rotation = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
      }

      let rect = target.getBoundingClientRect()

      // calculate top position
      let topPos = Math.round(rect.top - this.bounds.top)
      topPos = topPos <= 0 ? 0 : topPos
      let topPercentage = 100 / this.bounds.height * topPos

      // calculate bottom position
      let leftPos = Math.round(rect.left - this.bounds.left)
      leftPos = leftPos < 0 ? 0 : leftPos
      let leftPercentage = 100 / this.bounds.width * leftPos


      this.updateEmojiLocation({rotation: rotation, x: leftPercentage, y: topPercentage})
    },

    updateEmojiLocation(config) {
      let transform = Object.assign(this.emojiMap.transform, config)
      this.emojiMap = Object.assign(this.emojiMap, {transform: transform})

      this.$refs.delete.style.transform = 'rotate(' + -config.rotation + 'deg)'
    },

    remove() {
      this.$store.commit('removeEmojiFromMap', this.emojiMap.id)
    },
  },
}
</script>